import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const tariffDataApi = createApi({
  reducerPath: 'tariffDataApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getTariffData: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/${params.id}`
      })
    }),
    postTariffData: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/many`,
        body: { data: data },
        method: 'POST'
      }),
      invalidatesTags: [
        'getTariffDataByConsumerType',
        'getTariffDataBySupplyType',
        'getAllTariffs'
      ]
    }),
    updateTariffData: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: [
        'getTariffDataByConsumerType',
        'getTariffDataBySupplyType',
        'getAllTariffs'
      ]
    }),
    deleteTariffData: builder.mutation({
      query: (id) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['getAllTariffs']
    }),
    getTariffDataConsumers: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/consumers`,
        body: data,
        method: 'POST'
      }),
      providesTags: ['tariffDataConsumers']
    }),
    getTariffByConsumerCategory: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/consumer/${params}`
      }),
      providesTags: ['getTariffDataByConsumerType']
    }),
    getTariffBySuppyTypeCode: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/tariff_data/supply/${params}`
      }),
      providesTags: ['getTariffDataBySupplyType']
    }),
    getTariffList: builder.query({
      query: () => ({
        url: `${mdmsUrl}/prepaid-engine/mdms_api/list/tariffs`
      }),
      providesTags: ['getAllTariffs']
    }),
    tariffDropdowns: builder.query({
      query: () => ({
        url: `${mdmsUrl}/prepaid-engine/mdms_api/tariff/dropdowns`
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetTariffDataQuery,
  usePostTariffDataMutation,
  useDeleteTariffDataMutation,
  useLazyGetTariffByConsumerCategoryQuery,
  useLazyGetTariffBySuppyTypeCodeQuery,
  useGetTariffDataConsumersMutation,
  useUpdateTariffDataMutation,
  useGetTariffListQuery,
  useTariffDropdownsQuery
} = tariffDataApi;
